/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  CreateContactMemoResponseData,
  CreateContactMemoResponseDataFromJSON,
  CreateContactMemoResponseDataFromJSONTyped,
  CreateContactMemoResponseDataToJSON
} from './CreateContactMemoResponseData'

/**
 *
 * @export
 * @interface UpdateContactMemoResponse
 */
export interface UpdateContactMemoResponse {
  /**
   *
   * @type {number}
   * @memberof UpdateContactMemoResponse
   */
  status?: number
  /**
   *
   * @type {CreateContactMemoResponseData}
   * @memberof UpdateContactMemoResponse
   */
  data?: CreateContactMemoResponseData
}

export function UpdateContactMemoResponseFromJSON(json: any): UpdateContactMemoResponse {
  return UpdateContactMemoResponseFromJSONTyped(json, false)
}

export function UpdateContactMemoResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UpdateContactMemoResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : CreateContactMemoResponseDataFromJSON(json['data'])
  }
}

export function UpdateContactMemoResponseToJSON(value?: UpdateContactMemoResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: CreateContactMemoResponseDataToJSON(value.data)
  }
}
